import { ref } from 'vue';
import { useUserStore } from '~/composables/useUserStore';
import {
    fetchReads,
    fetchReadById,
    postRead,
    updateRead,
    removeRead,
    fetchReadBySlug,
    updateContentOrder
} from '~/api/readApi';

const reads = ref<any[]>([]);

export function useReadStore() {
    const { token } = useUserStore();

    const loadReads = async (query = {}) => {
        try {
            reads.value = await fetchReads(query);
        } catch (error) {
            console.error('Failed to load reads:', error);
        }
    };

    const searchReads = async (query = {}) => {
        try {
            const response = await fetchReads(query);
            return { reads: response };
        } catch (error) {
            console.error('Failed to search reads:', error);
            return { reads: [] };
        }
    };

    const loadReadById = async (id: string) => {
        try {
            return await fetchReadById(id);
        } catch (error) {
            console.error('Failed to load read:', error);
        }
    };

    const loadReadBySlug = async (slug: string) => {
        try {
            return await fetchReadBySlug(slug);
        } catch (error) {
            console.error('Failed to load read:', error);
        }
    };

    const newRead = async (payload: any) => {
        try {
            const response = await postRead(payload, token.value);
            return response;
        } catch (error) {
            console.error('Failed to create read:', error);
        }
    };

    const patchRead = async (payload: any, id: string) => {
        try {
            const response = await updateRead(payload, id, token.value);
            return response;
        } catch (error) {
            console.error('Failed to update read:', error);
        }
    };

    const deleteRead = async (id: string) => {
        try {
            const response = await removeRead(id, token.value);
            return response;
        } catch (error) {
            console.error('Failed to delete read:', error);
        }
    };

    const updateContentBlockOrder = async (readId: string, updatedContent: any[]) => {
        try {
            const response = await updateContentOrder({ readId, content: updatedContent }, token.value);
            return response;
        } catch (error) {
            console.error('Failed to update content block order:', error);
        }
    };

    return {
        reads,
        loadReads,
        loadReadById,
        newRead,
        patchRead,
        deleteRead,
        updateContentBlockOrder,
        loadReadBySlug,
        searchReads
    };
}
